import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import withRouter from "../Common/withRouter";
import { withTranslation } from "react-i18next";
import SidebarContent from "./SidebarContent";
import { Link } from "react-router-dom";
import logoLightSvg from "../../assets/images/logo-light.svg";
import { useAccountBrandingContext, useActiveAccountId } from "../../context/account-branding-context";
import { buildScopedPath } from "../../utils/account-context";
import { resolveBrandedLogoDisplayUrls } from "../../utils/account-branding-theme";

import {
  TvDiv,
  TvImg,
  TvSpan,
} from "@trustvid/design-system";

const Sidebar = props => {
  const { branding } = useAccountBrandingContext();
  const activeAccountId = useActiveAccountId();
  const { iconSrc } = resolveBrandedLogoDisplayUrls(branding);

  const logoTargetPath = activeAccountId ? buildScopedPath(activeAccountId, "/dashboard") : "/login";
  const defaultMark = require("../../assets/images/trustvid-logo.png");
  const sidebarIcon = iconSrc || defaultMark;

  return (
    <React.Fragment>
      <TvDiv className="vertical-menu">
        <TvDiv className="navbar-brand-box">
          <Link to={logoTargetPath} className="logo logo-dark" data-testid="sidebar-logo-link">
            <TvSpan className="logo-sm">
              <TvImg src={sidebarIcon} alt="logo" className="rounded-circle" height="34" />
            </TvSpan>
          </Link>
          <Link to={logoTargetPath} className="logo tv-saas-sidebar__brand">
            <TvDiv className="tv-saas-sidebar__brand-row">
              <TvSpan className="logo-sm">
                <TvImg src={iconSrc || logoLightSvg} alt="" className="tv-saas-sidebar__mark-img" />
              </TvSpan>
              <TvSpan className="logo-lg tv-saas-sidebar__brand-lg">
                <TvImg
                  src={sidebarIcon}
                  alt="Trustvid"
                  className="tv-saas-sidebar__mark-img tv-saas-sidebar__mark-img--lg"
                />
                <TvSpan className="tv-saas-sidebar__brand-text">Trustvid</TvSpan>
              </TvSpan>
            </TvDiv>
          </Link>
        </TvDiv>
        <TvDiv data-simplebar className="h-100">
          <SidebarContent isCollapsed={props.type === "condensed"} />
        </TvDiv>
        <TvDiv className="sidebar-background"></TvDiv>
      </TvDiv>
    </React.Fragment>
  );
};

Sidebar.propTypes = {
  type: PropTypes.string,
};

const mapStatetoProps = state => ({
  layout: state.Layout,
});

export default connect(mapStatetoProps, {})(withRouter(withTranslation()(Sidebar)));
